import React, { useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { toast } from "react-toastify";
import MuiBankCardSelect from "./MuiBankCardSelect";
import CardForm from "./CardForm";
import ShowAddress from "./ShowAddress";

const ShippingDetails = ({
  toggleRun,
  setBal,
  totalPrice,
  setIsComplete,
  isShippingAddressFullFil,
  setIsShippingAddressFullfil,
  setIsProceedToPay,
  shippingDetails,
}) => {
  const [value, setValue] = useState("");
  return (
    <section>
        <div
      className={`shipping_details_view ${
        isShippingAddressFullFil && "show-shipping-details-view"
      } ${value !== "" && "shipping_Details_opacity_zero"}`}
    >
      <div className="shipping_details_show_inside">
        <div className="shipping_payment_method_flex">
          <ShowAddress shippingDetails={shippingDetails} />
          <div>
            <h4 className="py-choose-op">
              Choose Your Payment Option. (<span>{totalPrice}$</span>)
            </h4>
            <div className="payment-btn-area-widht">
              <PayPalScriptProvider
                options={{
                  "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
                }}
              >
                <PayPalButtons
                  style={{ layout: "horizontal" }}
                  createOrder={(data, actions) => {
                    return actions.order.create({
                      purchase_units: [
                        {
                          amount: {
                            value: totalPrice,
                          },
                        },
                      ],
                    });
                  }}
                  onApprove={async (data, actions) => {
                    return actions.order.capture().then(function (details) {
                      console.log(details);
                      toast.success(
                        `Payment successful by ${details.payer.name.given_name}`,
                        { position: "top-center" }
                      );
                      setBal({ bal: details.create_time, sal: details.status });
                      if (details.status === "COMPLETED") {
                        toggleRun(true);
                        setIsComplete("completed");
                        setIsProceedToPay(false);
                        setIsShippingAddressFullfil(false);
                      }
                    });
                  }}
                />
              </PayPalScriptProvider>
              <MuiBankCardSelect setValue={setValue} value={value} />
            </div>
          </div>
        </div>
        <div className="btn_cls_all_container">
          <button onClick={() => setIsShippingAddressFullfil(false)}>
            Change Address
          </button>
          <button
            onClick={() => {
              setIsShippingAddressFullfil(false);
              setIsProceedToPay(false);
            }}
          >
            Close All
          </button>
        </div>
      </div>
    </div>
    <CardForm
        totalPrice={totalPrice}
        value={value}
        setValue={setValue}
        setIsProceedToPay={setIsProceedToPay}
        setIsShippingAddressFullfil={setIsShippingAddressFullfil}
        toggleRun={toggleRun}
        setIsComplete={setIsComplete}
      />
    </section>
  );
};

export default ShippingDetails;
